export const FINANCE_CALCULATOR_MODAL_ID = 'finance-calc-modal';

export const BASE_URL_QA = 'https://finance-calculator-qa.ideal4finance.co.uk/';

export const BASE_URL_PROD = 'https://finance-calculator.ideal4finance.co.uk/';
